module.exports = __webpack_public_path__ + "img/moren-guanggao.93c3966f.jpg";